//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getLoginConfig } from "@/api/login";
export default {
  name: "Footer",
  components: {},
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      copyrightInfo: ""
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    getLoginConfig().then(function (res) {
      if (res.data.success) {
        _this.copyrightInfo = res.data.data.copyright_info;
      }
    });
  },
  destroyed: function destroyed() {},
  methods: {},
  watch: {},
  filters: {}
};